<!--字典表-->
<template>
	<treeBody>
		<enumTree ref="enumTreeBean" slot="tree" @checkItem='nowEnum = $event;nowEnumItem=undefined ;$refs.EnumItemList.nowCheckIndex=-1'></enumTree>
		<div class="rightBody" slot="body" >
			<div class="buttonLine">
				<iconButton @buttonClick='addEnum' buttonText='添加字典' icoName="wedoButton/add.png"></iconButton>
				<iconButton @buttonClick='deleteEnum' buttonText='删除字典' icoName="wedoButton/delete.png"></iconButton>
				<iconButton @buttonClick='editEnum' buttonText='编辑字典' icoName="wedoButton/edit.png"></iconButton>
			</div>
			<infoList ref="EnumList" style="height: auto" :columns='EnumColumns' :dataList="EnumInfo" :pageLen='1' :totalSize="1" :showIndex="false" :fillAll="true"></infoList>
			<div class="buttonLine">
				<iconButton @buttonClick='addEnumItem' buttonText='添加字典项' icoName="wedoButton/add.png"></iconButton>
				<iconButton @buttonClick='deleteEnumItem' buttonText='删除字典项' icoName="wedoButton/delete.png"></iconButton>
				<iconButton @buttonClick='editEnumItem' buttonText='编辑字典项' icoName="wedoButton/edit.png"></iconButton>
			</div>
			<infoList ref="EnumItemList" style="height: calc(100% - 180px)" :columns='EnumItemColumns' :dataList="showEnumItemInfo" :pageLen='20'
			 :totalSize="EnumItemInfo.length"  :fillAll="true" @checkItem="nowEnumItem  = $event"  @selectPage='nowIndex=$event'></infoList>
		</div>
	</treeBody>
</template>

<script>
	import treeBody from '@/components/module/slotModule/treeBody.vue'
	import enumTree from '@/components/module/tree/enumTree.vue'
	import iconButton from '@/components/module/universal/iconButton.vue'
	import infoList from '@/components/module/universal/infoList.vue'
	import nomalInputDialog from '@/components/module/dialog/nomalInputDialog.vue'
	export default {
		components: {
			treeBody,
			enumTree,
			iconButton,
			infoList,
		},
		props: [],
		data() {
			return {
				nowEnum: {},
				nowIndex:0,
				nowEnumItem: undefined,
				EnumColumns: [{//驼峰没改
					name: '字典编码',
					key: 'enumcode',
				}, {
					name: '字典名称',
					key: 'enumname',
				}, {
					name: '是否允许编辑', 
					key: 'editable',
					format(value){
						return value == 1? "是" : "否"
					}
				}, {
					name: '创建时间',
					key: 'createTime',
					format(value){
						if (isempty(value)) {
							return ''
						}
						return new Date(value).formatByTime()
					}
				}],
				EnumItemColumns: [{
					name: '字典项名称', 
					key: 'itemText',
				}, {    
					name: '值',
					key: 'itemValue',
				}, {
					name: '是否允许编辑',
					key: 'editable',
					format(value){
						return value == 1? "是" : "否"
					}
				}, {
					name: '创建时间',
					key: 'createTime',
					format(value){
						if (isempty(value)) {
							return ''
						}
						return new Date(value).formatByTime()
					}
				}],
			}
		},
		created() {
			debugPage = this
		},
		mounted() {},
		destroyed() {},
		computed: {
			enumTree() { 
				return this.$store.enumStore.getters.getEnumTree
			},
			EnumInfo() {
				return [copy(this.nowEnum)]
			},
			EnumItemInfo() {
				if(isempty(this.nowEnum.next)) {
					return []
				}
				return copy(this.nowEnum.next)
			},
			showEnumItemInfo(){
				var datas = this.EnumItemInfo
				var index = this.nowIndex*20
				var limit = index+20
				datas =  datas.filter((d,i)=>{
					return   i<limit && i>=index
				})
				return  datas.sort((a,b)=>{
					return b.createTime - a.createTime
				})
			}
		},
		watch: {},
		methods: {
			addEnum() {
				var dialog = this.$dialogMethod.createDialog(nomalInputDialog)
				dialog.open('添加字典', [{
					name: '字典编码',
					pkid: 'enumCode'
				}, {
					name: '字典名称',
					pkid: 'enumName'
				}], item => {
					if(isempty(item.enumCode)){
						this.$dialogMethod.showMessage("字典编码不能为空!")
						return false
					}
					if(isempty(item.enumName)){
						this.$dialogMethod.showMessage("字典名称不能为空!")
						return false
					}
					this.$api.enumApi.addEnum(item.enumCode, item.enumName, '', respon => {
						this.$dialogMethod.showMessage("添加成功!")
						this.$store.enumStore.state.enumTree.push(respon)
					}, respon => {
						this.$dialogMethod.showMessage(respon)
					})
				})
			},
			deleteEnum(item) {
				if(this.nowEnum.editable===0){
					this.$dialogMethod.showMessage("当前字典项不允许编辑!")
					return
				}
				this.$dialogMethod.openAgreeDialog('删除字典', "是否删除 " + this.nowEnum.enumname + " 及相关属性?", () => {
					this.$api.enumApi.deleteEnum(this.nowEnum.enumcode, respon => {
						this.$dialogMethod.showMessage("删除字典成功!")
						this.$store.enumStore.state.enumTree = this.$store.enumStore.state.enumTree.filter(item => {
							return item.enumcode != this.nowEnum.enumcode
						})
						this.$refs.EnumList.nowCheckIndex = -1
						this.$refs.enumTreeBean.checkItem(this.$store.enumStore.state.enumTree[0])//删除之后重新点击下当前树存在的第一个可用节点以刷新删除掉的页面
						
					}, respon => {
						this.$dialogMethod.showMessage(respon)
					})
				})
			},
			editEnum() {
				if(this.nowEnum.editable===0){
					this.$dialogMethod.showMessage("当前字典项不允许编辑!")
					return
				}
				var dialog = this.$dialogMethod.createDialog(nomalInputDialog)
				dialog.open('编辑字典', [{
					name: '字典名称',
					pkid: 'enumName',
					defaultValue:this.nowEnum.enumname
				}], item => {
					if(isempty(item.enumName)){
						this.$dialogMethod.showMessage("字典名称不能为空!")
						return false
					}
					this.$api.enumApi.updateEnum(this.nowEnum.enumcode, item.enumName, '', respon => {
						this.$dialogMethod.showMessage("更新成功!")
						this.nowEnum.enumname = item.enumName
					}, respon => {
						this.$dialogMethod.showMessage(respon)
					})
				})
			},
			addEnumItem() {
				if(this.nowEnum.editable===0){
					this.$dialogMethod.showMessage("当前字典项不允许编辑!")
					return
				}
				var dialog = this.$dialogMethod.createDialog(nomalInputDialog)
				dialog.open('添加字典项', [{
					name: '名称',
					pkid: 'itemText',
				}, {
					name: '值',
					pkid: 'itemValue',
				}], item => {
					if(isempty(item.itemText)){
						this.$dialogMethod.showMessage("名称不能为空!")
						return false
					}
					if(isempty(item.itemValue)){
						this.$dialogMethod.showMessage("值不能为空!")
						return false
					}
					//计算序号
					var sort = 0
					if(!isempty(this.EnumItemInfo)) {
						sort = this.EnumItemInfo[this.EnumItemInfo.length - 1].sort + 1
					}
					this.$api.enumApi.addEnumItem(this.nowEnum.enumcode, item.itemText, item.itemValue, sort, respon => {
						this.$dialogMethod.showMessage("添加字典项成功!")
						this.nowEnum.next.push(respon)
					}, respon => {
						this.$dialogMethod.showMessage(respon)
					})
				})
			},
			deleteEnumItem() {
				if(this.nowEnum.editable===0){
					this.$dialogMethod.showMessage("当前字典项不允许编辑!")
					return
				}
				if(this.nowEnumItem == undefined) {
					this.$dialogMethod.showMessage("请先选中要删除的字典项!")
					return
				}
				this.$dialogMethod.openAgreeDialog('删除字典项', "是否删除字典项 " + this.nowEnumItem.itemText + "?", () => {
					this.$api.enumApi.deleteEnumItem(this.nowEnumItem.pkid, respon => {
						this.$dialogMethod.showMessage("删除字典项成功!")
						this.nowEnum.next = this.nowEnum.next.filter(item => {
							return item.pkid != this.nowEnumItem.pkid
						})
						this.nowEnumItem = undefined
						this.$refs.EnumItemList.nowCheckIndex = -1
					}, respon => {
						this.$dialogMethod.showMessage(respon)
					})
				})
			},
			editEnumItem() {
				if(this.nowEnum.editable===0){
					this.$dialogMethod.showMessage("当前字典项不允许编辑!")
					return
				}
				if(this.nowEnumItem == undefined) {
					this.$dialogMethod.showMessage("请先选中要删除的字典项!")
					return
				}
				
				var dialog = this.$dialogMethod.createDialog(nomalInputDialog)
				dialog.open('编辑字典项', [{
					name: '名称',
					pkid: 'itemText',
					defaultValue:this.nowEnumItem.itemText
				}, {
					name: '值',
					pkid: 'itemValue',
					defaultValue:this.nowEnumItem.itemValue
				}], item => {
					if(isempty(item.itemText)){
						this.$dialogMethod.showMessage("名称不能为空!")
						return false
					}
					if(isempty(item.itemValue)){
						this.$dialogMethod.showMessage("值不能为空!")
						return false
					}
					this.$api.enumApi.updateEnumItem(this.nowEnumItem.pkid, item.itemText, item.itemValue, this.nowEnumItem.sort, respon => {
						this.$dialogMethod.showMessage("更新字典项成功!")
						var enumitem = this.nowEnum.next.find(it => {
							return it.pkid == this.nowEnumItem.pkid
						})
						enumitem.itemText = item.itemText
						enumitem.itemValue = item.itemValue
					}, respon => {
						this.$dialogMethod.showMessage(respon)
					})
				})
			},
		}
	}
</script>

<style scoped>
	
	.rightBody {
		width: 100%;
		height: 100%;
		overflow: hidden;
	}
	
</style>
